"use client";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import "react-toastify/dist/ReactToastify.css";

// Dynamically import ToastContainer
const ToastContainer = dynamic(
  () => import("react-toastify").then((mod) => mod.ToastContainer),
  {
    ssr: false,
    loading: () => null,
  },
);

interface LazyToastContainerProps {
  position?:
    | "top-right"
    | "top-left"
    | "top-center"
    | "bottom-right"
    | "bottom-left"
    | "bottom-center";
  autoClose?: number | false;
  hideProgressBar?: boolean;
  newestOnTop?: boolean;
  closeOnClick?: boolean;
  rtl?: boolean;
  draggable?: boolean;
  theme?: "light" | "dark" | "colored";
}

export const LazyToastContainer = ({
  position = "top-right",
  autoClose = 5000,
  hideProgressBar = true,
  newestOnTop = false,
  closeOnClick = true,
  rtl = false,
  draggable = true,
  theme = "dark",
}: LazyToastContainerProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Only render ToastContainer when component mounts
    setShouldRender(true);
  }, []);

  if (!shouldRender) {
    return null;
  }

  return (
    <ToastContainer
      position={position}
      autoClose={autoClose}
      hideProgressBar={hideProgressBar}
      newestOnTop={newestOnTop}
      closeOnClick={closeOnClick}
      rtl={rtl}
      draggable={draggable}
      theme={theme}
    />
  );
};
